import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification, Select } from 'antd';
import { IoIosList, IoMdDocument } from "react-icons/io";
import { RiFileExcel2Fill } from "react-icons/ri";
import { getProducts } from '../services/ProductsService';
import { getActiveCategories } from '../services/CategoriesService';
import { getAllPlants } from '../services/PlantsService';
import { getStock } from '../services/StockService';
import ReactExport from "react-export-excel";

import MovementProductsModal from './MovementProductsModal';
import ModalCategory from './ModalCategory';


const { Option } = Select;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function StockMaterials(){
  const[dataTableCompleta, setDataTableCompleta] = useState([]);
  const[tableLoading, setTableLoading] = useState(false);
  const[storageLoading, setStorageLoading] = useState(false);
  const[dataProducts, setDataProducts] = useState([]);
  const[dataCategories, setDataCategories] = useState([]);
  const[dataPlantsStorage, setDataPlantsStorage] = useState([]);
  const[dataStorage, setDataStorage] = useState([]);
  const[modalVisibleProducts, setModalVisibleProducts] = useState(false);
  const[modalVisibleCat, setModalVisibleCat] = useState(false);
  const[filterCategory, setfilterCategory] = useState([]);
  const[selectedProducts, setSelectedProducts] = useState([]);
  const[selectedStorage, setSelectedStorage] = useState([]);
  const[selectedPlants, setSelectedPlants] = useState([]);
  const[selectedCat, setSelectedCat] = useState([]);
  const[btnExcelVisible, setBtnExcelVisible] = useState(false);
  

    useEffect(() => {
        async function plantsStorage(){
            setStorageLoading(true);
            const { data } = await getAllPlants();
            setDataPlantsStorage(data);
            setDataStorage(data[0].storageLocations);
            setStorageLoading(false);
        }
        async function categorias(){
            const { data } = await getActiveCategories();
            const filter = [];
            data.map(function(obj){
            const item = {
                "text": obj.name,
                "value": obj.name
            };
            filter.push(item);
            return true;
            });
            setDataCategories(data);
            setfilterCategory(filter);
        }
        
        async function products(){
            const { data } = await getProducts();
            setDataProducts(data);
        }
        plantsStorage();
        products();
        categorias();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    function handleChangePlant(value) {
      setSelectedPlants(value);
        
    }

    function handleChangeStorage(value) {
      setSelectedStorage(value);
        
    }

    const handleCancelModalProducts = () =>{
      setModalVisibleProducts(false);
    }

    const handleOkModalProducts = (data) =>{
      setSelectedProducts(data);
      setModalVisibleProducts(false);
    }

    const handleClickModalMovProd = () =>{
      setModalVisibleProducts(true);
    }

    const handleCancelModalCat = () =>{
      setModalVisibleCat(false);
    }

    const handleOkModalCat = (data) =>{
      setSelectedCat(data);
      setModalVisibleCat(false);
    }

    const handleClickModalCat = () =>{
      setModalVisibleCat(true);
    }

    const handleClickReport = async () =>{
      setDataTableCompleta([]);
      setBtnExcelVisible(false);
      const request = {
        "Plants" : selectedPlants,
        "Products" : selectedProducts,
        "StorageLocations" : selectedStorage,
        "CategoriesRange" : selectedCat
      }
      setTableLoading(true);
      async function getReport(){
        const { data } = await getStock(request);
        if(data.length === 0){
          msNotification('info', 'Reporte', 'No se encontraron datos con los filtros seleccionados.' );
        }else{
          setBtnExcelVisible(true);
        }
        
        setDataTableCompleta(data);
        setTableLoading(false);
      }
      getReport();
    }

    

    const rowClassColor = (record, index) => record.valueStock >= 0 ? 'rowGreen' : 'rowRed';

    const columnsComplete = [
      {
        title: 'ID',
        dataIndex: 'product',
        width: 100,
        fixed: 'left',
        render: (value) => (value.id)
      },
      {
        title: 'Producto',
        dataIndex: 'product',
        render: (value) => (value.name)
      },
      {
        title: 'Categoría',
        dataIndex: 'category',
        render: (value) => (value.name)
      },
      {
        title: 'Stock',
        dataIndex: 'stock',
        render: (value) => (value)
      },
      {
        title: 'Unidad',
        dataIndex: 'unitOfMeasure',
        render: (value) => (value.unit)
      },
      {
        title: 'Stock transito',
        dataIndex: 'stockInTransit',
        render: (value) => (value)
      },
      {
        title: 'Stock seguridad',
        dataIndex: 'safeStock',
        render: (value) => (value)
      },
      {
        title: 'costo',
        dataIndex: 'product',
        render: (value) => (value.cost)
      },
      {
        title: 'Valor stock',
        dataIndex: 'valueStock',
        render: (value) => (value)
      },
      {
        title: 'Valor stock transito',
        dataIndex: 'valueStockInTransit',
        render: (value) => (value)
      },
      {
        title: 'Almacén',
        dataIndex: 'storageLocation',
        render: (value) => (value.name)
      },
      {
        title: 'Planta',
        dataIndex: 'plant',
        render: (value) => (value.name)
      },
      {
        title: 'Usuario',
        dataIndex: 'user',
        render: (value) => (value.userName)
      },
      
    ];
    
    

    return(
      <div className="mainContainer">

        <MovementProductsModal modalVisibleProducts={modalVisibleProducts} 
        handleCancelModalProducts={handleCancelModalProducts}
        handleOkModalProducts={handleOkModalProducts}
        dataProducts={dataProducts}
        filterCategory={filterCategory}/>

        <ModalCategory modalVisibleCat={modalVisibleCat} 
        handleCancelModalCat={handleCancelModalCat}
        handleOkModalCat={handleOkModalCat}
        dataCategories={dataCategories}/>

        <Row>
            <Col span={24}>
                <h1 className="title">Reporte de inventario</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>

        <Row className="detailContainer">
          <Col span={20}></Col>
          <Col span={4}>
            <div className="">
              <Button block type="primary" icon={<IoMdDocument/>} onClick={handleClickReport}>
                &nbsp; Generar
              </Button>
            </div>
          </Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoIosList/>} onClick={handleClickModalMovProd}>
                &nbsp; Productos...
              </Button>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoIosList/>} onClick={handleClickModalCat}>
                &nbsp; Categorias...
              </Button>
            </div>
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangePlant} 
              placeholder="Plantas..."
              maxTagCount='responsive'>
                {dataPlantsStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangeStorage} 
              placeholder="Almacenes..."
              maxTagCount='responsive'>
                {dataStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>
          
          <Col span={24}>
            <Row>
                <Col span={24}><br /></Col>
                <Col span={6} className={"collapse" + (btnExcelVisible ? 'in' : '')}>
                <ExcelFile filename="Reporte-Inventario" element={<Button block type="primary" icon={<RiFileExcel2Fill/>}> Descargar datos</Button>}>
                    <ExcelSheet data={dataTableCompleta} name="Inventario">
                        <ExcelColumn label="ID" value={(col) => col.product.id}/>
                        <ExcelColumn label="Producto" value={(col) => col.product.name}/>
                        <ExcelColumn label="Categoría" value={(col) => col.category.name}/>
                        <ExcelColumn label="Stock" value="stock"/>
                        <ExcelColumn label="Unidad" value={(col) => col.unitOfMeasure.unit}/>
                        <ExcelColumn label="Stock transito" value="stockInTransit"/>
                        <ExcelColumn label="Stock seguridad" value="safeStock"/>
                        <ExcelColumn label="Costo" value={(col) => col.product.cost}/>
                        <ExcelColumn label="Valor stock" value="valueStock"/>
                        <ExcelColumn label="Valor stock transito" value="valueStockInTransit"/>
                        <ExcelColumn label="Almacén" value={(col) => col.storageLocation.name}/>
                        <ExcelColumn label="Planta" value={(col) => col.plant.name}/>
                        <ExcelColumn label="Usuario" value={(col) => col.user.userName}/>
                    </ExcelSheet>
                    
                </ExcelFile>
                </Col>
                <Col span={24}>
                <br/>
                <Table rowKey="key" dataSource={dataTableCompleta} columns={columnsComplete} 
                    loading={tableLoading} scroll={{ x:'auto' }}
                    rowClassName={rowClassColor}/>
                </Col>
            </Row>
          </Col>
              
        </Row>
      </div>
    );
}

export default StockMaterials;



// WEBPACK FOOTER //
// ./src/components/StockMaterials.jsx